<template>
    <div>
        <label><span class="list-label">Sort by</span>
            <span class="custom-select">
                <select class="form-control custom-dropdown" v-model="sort" @change="update">
                    <option value="">Relevance</option>
                    <!-- <option v>Top Selling</option> -->
                    <template v-if="category">
                        <option value="min_price-asc">Price: Low to High</option>
                        <option value="min_price-desc">Price: High to Low</option>
                    </template>
                    <template v-else>
                        <option value="brand-asc">Brand: A - Z</option>
                        <option value="brand-desc">Brand: Z - A</option>
                        <option value="price-asc">Price: Low to High</option>
                        <option value="price-desc">Price: High to Low</option>
                    </template>
                </select>
            </span>
        </label>
    </div>
</template>

<script>
    import Search from '../../Services/Search.js';

    export default {
        props: {
            initial: {
                default: null
            },
            category: {
                default: false,
            }
        },
        data() {
            return {
                service: Search
            }
        },
        mounted() {
            if (this.initial) {
                this.sort = this.initial;
            }
            // _.each(this.initial, (value, key) => {
            //     this.service.setSort(key, value);
            // });
        },
        methods: {
            update() {
                this.$emit('sorted', this.sort);
            }
        },
        computed: {
            sort: {
                get: function() {
                    return this.service.sort;
                },
                set: function (val) {
                    this.service.setSort(val);
                }
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Search/SearchSort.vue